import { CommonModule } from '@angular/common';
import { Inject, ModuleWithProviders, NgModule } from '@angular/core';

import { CmpsCommonModule } from '../common/common.module';

import { WidgetComponent } from './widget.component';
import { CMPS_WIDGET_WIDGETS } from './widget.metadata';
import { Widgets } from './widget.model';
import { WidgetService } from './widget.service';

@NgModule({
    imports: [CommonModule, CmpsCommonModule],
    declarations: [WidgetComponent],
    exports: [WidgetComponent],
})
export class CmpsWidgetModule {
    constructor(
        private readonly _service: WidgetService,
        @Inject(CMPS_WIDGET_WIDGETS) private readonly _widgets: Widgets[],
    ) {
        _service.widgets = _widgets.reduce((p, c) => {
            p = p.concat(c);
            return p;
        }, []);
    }

    static forRoot(): ModuleWithProviders<CmpsWidgetModule> {
        return {
            ngModule: CmpsWidgetModule,
            providers: [WidgetService],
        };
    }

    static forChild(widgets: Widgets): ModuleWithProviders<CmpsWidgetModule> {
        return {
            ngModule: CmpsWidgetModule,
            providers: [
                {
                    provide: CMPS_WIDGET_WIDGETS,
                    useValue: widgets,
                    multi: true,
                },
            ],
        };
    }
}
